import { render, staticRenderFns } from "./OrderFooterDisabled.vue?vue&type=template&id=3b327e9a&"
import script from "./OrderFooterDisabled.vue?vue&type=script&lang=js&"
export * from "./OrderFooterDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports